import BulkServiceConfigurationPanel from './bulk-service-configuration-panel';

export default BulkServiceConfigurationPanel;
